<template>
  <ProSpaceModal :key="`validate-modal-${show}`"
    v-model="show"
    width="460"
    height="650"
    :title="isEdit ? $t('editItemTxt') : `${$t('newTxt')} ${$t('userLower')}`"
    :icon="isEdit ? 'edit' : 'plus'"
    class="modal-user"
    :loading="loading"
    @apply="sendRequest"
    :validate-local="$t"
    :validate-model="model"
    :validate-config="{
      firstName: { required },
      lastName: { required },
      secondName: { required },
      email: {
        required,
        email: {
          fn: Validations.isEmail,
          message: $t('notValidEmail'),
        }
      },
      login: {
        required,
        validLogin: {
          fn: loginValidate,
          message: $t('notValidLogin'),
        }
      },
      securityLoginAuthenticateProvider: { required },
      agencyLinkType: { required },
      agencyLinkAgencyId: {
        agency: {
          message: $t('requiredFieldErrorMessage'),
          fn: agencyValidate
        }
      },
    }"
  >
    <template #default="{ v }">
      <ProSpaceTabs ref="tabs" :tabs="tabs" is-full-width>
        <template v-slot:tab-1>
          <ProSpaceVLayout :gap="20" style="margin-top: 20px; padding-bottom: 20px">
            <ProSpaceDropdown
              ref="userTypeDropdown"
              :label="$t('userType')"
              :placeholder="$t('selectTxt')"
              :service="userService"
              getMethod="getTypes"
              v-model="model.agencyLinkType"
              propValue="value"
              propLabel="text"
              @change="userTypeChanged"
              :invalid="v.agencyLinkType.$error"
              :invalid-messages="v.agencyLinkType.$errors"
              @blur="v.agencyLinkType.$touch"
            />
            <ProSpaceDropdown
              v-if="model.agencyLinkType === 'AGENCY'"
              v-model="model.agencyLinkAgencyId"
              ref="agencySearch"
              :label="$t('userAgency')"
              :placeholder="$t('selectTxt')"
              :service="agencyService"
              getMethod="grid"
              propValue="id"
              propLabel="value"
              argMethod="$filter=disabled eq false"
              @change="(item) => (model.agencyLinkAgencyValue = item?.value)"
              :invalid="v.agencyLinkAgencyId.$error"
              :invalid-messages="v.agencyLinkAgencyId.$errors"
              @blur="v.agencyLinkAgencyId.$touch"
            />
          </ProSpaceVLayout>
        </template>
        <template v-slot:tab-2>
          <ProSpaceVLayout :gap="20" style="margin-top: 20px;">
            <ProSpaceInputText
              :label="$t('lastName')"
              v-model="model.lastName"
              :placeholder="$t('lastName')"
              :invalid="v.lastName.$error"
              :invalid-messages="v.lastName.$errors"
              @blur="v.lastName.$touch"
            />
            <ProSpaceInputText
              :label="$t('firstName')"
              v-model="model.firstName"
              :placeholder="$t('firstName')"
              :invalid="v.firstName.$error"
              :invalid-messages="v.firstName.$errors"
              @blur="v.firstName.$touch"
            />
            <ProSpaceInputText
              :label="$t('secondName')"
              v-model="model.secondName"
              :placeholder="$t('secondName')"
              :invalid="v.secondName.$error"
              :invalid-messages="v.secondName.$errors"
              @blur="v.secondName.$touch"
            />
            <ProSpaceInputText
              :label="$t('email')"
              v-model="model.email"
              :placeholder="$t('email')"
              :invalid="v.email.$error"
              :invalid-messages="v.email.$errors"
              @blur="v.email.$touch"
            />
            <ProSpaceInputText
              v-if="isCreate"
              :label="$t('login')"
              v-model="model.login"
              :placeholder="$t('login')"
              :invalid="v.login.$error"
              :invalid-messages="v.login.$errors"
              @blur="v.login.$touch"
            />
            <ProSpaceDropdown
              v-if="isCreate"
              :label="$t('loginType')"
              :placeholder="$t('loginType')"
              v-model="model.securityLoginAuthenticateProvider"
              getMethod="get"
              :service="loginTypeService"
              :invalid="v.securityLoginAuthenticateProvider.$error"
              :invalid-messages="v.securityLoginAuthenticateProvider.$errors"
              @blur="v.securityLoginAuthenticateProvider.$touch"
            />
            <ProSpaceInputSwitch
              v-model="model.status"
              :label="$t('active')"
              falseValue="DEACTIVE"
              trueValue="ACTIVE"
              :noBorder="true"
            />
          </ProSpaceVLayout>
        </template>
      </ProSpaceTabs>
    </template>
    <template #footer="{ v }">
      <ProSpaceHLayout :gap="5" justify-content="flex-end" is-inline-w>
        <ProSpaceButton
          type="secondary"
          :label="$t('cancelTxt')"
          @click="show = false"
        />
        <ProSpaceButton
          type="primary"
          :label="modalBtnTxt"
          :icon="modalBtnIcon"
          :disabled="isDisabledBtn(v)"
          @click="() => primaryBtnHandler(v)"
        />
      </ProSpaceHLayout>
    </template>
  </ProSpaceModal>
</template>

<script>
import {
  ProSpaceModal,
  ProSpaceInputText,
  ProSpaceDropdown,
  ProSpaceInputSwitch,
  ProSpaceVLayout,
  ProSpaceSearchfield,
  ProSpaceTabs,
  ProSpaceRightPanel,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceTableHeaderCell,
  ProSpaceCustomFilterPanel,
  ProSpaceButton,
  ProSpaceHLayout,
  Validations
} from "@prospace/prospace-components-library";
import { UserService } from "../../../services/UserService.js";
import { DEFAULT_USER_DATE_PARAMETERS } from "../../../services/DateHelperService.js"
import { AgencyService } from "../../../../../AddressProgram/AddressProgram.Frontend/services/AgencyService";
import { LoginTypeService } from "../../../services/LoginTypeService.js";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Column from "primevue/column";
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "ModalUser",
  components: {
    ProSpaceModal,
    ProSpaceInputText,
    ProSpaceDropdown,
    ProSpaceInputSwitch,
    ProSpaceVLayout,
    ProSpaceSearchfield,
    ProSpaceTabs,
    Column,
    ProSpaceRightPanel,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceTableHeaderCell,
    ProSpaceCustomFilterPanel,
    ProSpaceButton,
    ProSpaceHLayout,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      model: {
        firstName: { required },
        lastName: { required },
        secondName: { required },
        email: { required },
        login: { required },
        securityLoginAuthenticateProvider: { required },
      },
    };
  },
  data() {
    return {
      Validations,
      show: false,
      model: null,
      mode: "create",
      userService: new UserService(),
      loginTypeService: new LoginTypeService(),
      agencyService: new AgencyService(),
      modalBtnTxt: this.$t("applyTxt"),
      modalBtnIcon: "check",
      loading: false,
      tabs: [
        { name: this.$t("userType"), value: "UserType", isActive: true },
        { name: this.$t("mainInfo"), value: "UserInfo", isActive: false },
      ],
    };
  },
  methods: {
    isDisabledBtn(valid) {
      return valid.$errors.length > 0
    },
    init(model) {
      this.show = true;
      if (model) {
        this.mode = "edit";
        this.model = _.cloneDeep(model);
      } else {
        this.mode = "create";
        this.model = {
          firstName: "",
          secondName: "",
          lastName: "",
          email: "",
          jobTitle: "",
          status: "ACTIVE",
          agencyLinkType: null,
          agencyLinkAgencyId: null,
          agencyLinkAgencyValue: null,
          dateFormat: DEFAULT_USER_DATE_PARAMETERS.dateFormat,
          timeFormat: DEFAULT_USER_DATE_PARAMETERS.timeFormat,
          timeZoneId: DEFAULT_USER_DATE_PARAMETERS.timeZoneId
        };
      }
      this.$nextTick(this.moveFirstTab);
    },
    agencyValidate(v) {
      const model = this.model;
      if (model.agencyLinkType === "MARS") return true;
      return !!v;
    },
    loginValidate(v) {
      if (this.isCreate) {
        const valid = this.Validations.custom('^(?=.*[A-Za-z])[A-Za-z0-9_.]+$')(v)
        return valid
      }
      return true
    },
    sendRequest(v) {
      if (!v.$dirty) {
        v.$touch();
      }
      if (v.$invalid) {
        this.checkValidFirstTab(v);
        return
      }
      this.loading = true;
      this.userService[this.mode](this.model).then((res) => {
        this.loading = false;
        if (res.data === true)
          this.close();
      })
        .catch(() => {
          this.loading = false;
        });
    },
    checkValidFirstTab(v) {
      if (v.agencyLinkAgencyId.$invalid && !this.tabs[0].isActive) {
        this.moveFirstTab()
      }
    },
    moveFirstTab() {
      this.$refs.tabs.select(this.tabs[0], 0)
    },
    close() {
      this.$emit("close");
      this.$emit("update:modalValue", false);
    },
    next() {
      this.$refs.tabs.select(
        { name: this.$t("mainInfo"), value: "UserInfo" },
        1
      );
    },
    userTypeChanged(option) {
      this.model.agencyLinkAgencyId = null;
      this.model.agencyLinkAgencyValue = null;
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    contentStyle() {
      return {
        height: "70vh",
        width: "95vw",
        minWidth: "1200px",
      };
    },
    isCreate() {
      return this.mode === "create";
    },
    isEdit() {
      return this.mode === "edit";
    },
    primaryBtnHandler() {
      return this.tabs[0].isActive ? this.next : this.sendRequest;
    },
  },
  watch: {
    tabs: {
      handler() {
        this.modalBtnTxt = this.tabs[0].isActive
          ? this.$t("next")
          : this.$t("save");
        this.modalBtnIcon = this.tabs[0].isActive ? null : "check";
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
</style>
